import { hot } from 'react-hot-loader/root';
import React from 'react';
import Layout from './Layout';
import './styles/App.scss';

function App({ geoJson }) {
  return <Layout geoJson={geoJson} />;
}

export default hot(App);
